
export const PKO = "PKO";
export const MBANK = "Mbank";
export const NOT_SPECIFIED = "NOT_SPECIFIED";
export const SWIFT_MAP = {
  [PKO]: "BPKOPLPWXXX",
  [MBANK]: "BREXPLPWXXX",
  [NOT_SPECIFIED]: "NOTSPECIFIED",
};
export const avalibleBanks = [
  {
    value: PKO,
    label: PKO
  },
  {
    value: MBANK,
    label: MBANK
  }
];
export const getSwiftCodeForBank = (bank) => {
  return SWIFT_MAP[bank] ?? null;
}

export const getBankFromSwiftCode = (swiftCode) => {
  return Object.keys(SWIFT_MAP).find(bank => SWIFT_MAP[bank] === swiftCode) ?? null;
}
